import React, { useState, useEffect } from 'react';
import { trackActivity } from '../../services/api';
import CapitalMarketAssumptions from './components/CapitalMarketAssumptions';
import PortfolioRegistryEditor from './components/PortfolioRegistryEditor';
import HistoricSAAEditor from './components/HistoricSAAEditor';
import PortfolioCodeMappingEditor from './components/PortfolioCodeMappingEditor';
import StressEventsEditor from './components/StressEventsEditor';
import MacroRegimesEditor from './components/MacroRegimesEditor';
import InvestmentChartsTab from './components/InvestmentChartsTab';
import PerformanceDateSelector from './components/PerformanceDateSelector';
import './InvestmentConfigApp.css';

const TABS = [
  { key: 'cma', label: 'Capital Market Assumptions', icon: 'bi-graph-up' },
  { key: 'portfolio-registry', label: 'Portfolio Registry', icon: 'bi-collection' },
  { key: 'code-mapping', label: 'Portfolio Mapping', icon: 'bi-diagram-3' },
  { key: 'historic-saa', label: 'Historic SAA', icon: 'bi-clock-history' },
  { key: 'charts', label: 'Charts', icon: 'bi-bar-chart-fill' },
  { key: 'stress-testing', label: 'Stress Events', icon: 'bi-exclamation-triangle' },
  { key: 'macro-regimes', label: 'Macro Regimes', icon: 'bi-bar-chart-line' },
  { key: 'performance-date', label: 'Performance Date Selection', icon: 'bi-calendar-check' },
];

const InvestmentConfigApp = () => {
  const [activeSection, setActiveSection] = useState('cma');

  useEffect(() => {
    trackActivity('app_access', 'investment_config');
  }, []);

  return (
    <div className="invest-config">
      <div className="invest-config-header">
        <h4>Investment Config</h4>
      </div>

      <div className="invest-config-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            className={`invest-config-tab ${activeSection === tab.key ? 'active' : ''}`}
            onClick={() => setActiveSection(tab.key)}
          >
            <i className={`bi ${tab.icon}`} />
            <span>{tab.label}</span>
          </button>
        ))}
      </div>

      <div className="invest-config-content">
        {activeSection === 'cma' && <CapitalMarketAssumptions />}
        {activeSection === 'portfolio-registry' && <PortfolioRegistryEditor />}
        {activeSection === 'code-mapping' && <PortfolioCodeMappingEditor />}
        {activeSection === 'historic-saa' && <HistoricSAAEditor />}
        {activeSection === 'charts' && <InvestmentChartsTab />}
        {activeSection === 'stress-testing' && <StressEventsEditor />}
        {activeSection === 'macro-regimes' && <MacroRegimesEditor />}
        {activeSection === 'performance-date' && <PerformanceDateSelector />}
      </div>
    </div>
  );
};

export default InvestmentConfigApp;
